import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Select,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import useTopBarStyles from "../../instructionStyle/default/topBarStyle";

const TopBar = ({
  toggleSidebar,
  handleChange,
  languages,
  selectedLanguage,
}) => {
  const classes = useTopBarStyles();
  const isDesktop = useMediaQuery("(min-width:900px)");

  return (
    <AppBar position="static" elevation={2}>
      <Toolbar className={classes.toolbar}>
        {!isDesktop &&
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleSidebar}
          size="large"
          className={classes.hamburger}
        >
          
          <MenuIcon />
        </IconButton>
          }


        {isDesktop && <div style={{ width: "40%" }}></div>}

        <Typography variant="h5" component="div" className={classes.title}>
          Instructions
        </Typography>

        <Select
          value={selectedLanguage}
          onChange={handleChange}
          size="small"
          className={classes.select}
        >
          {languages?.map((l, i) => (
            <MenuItem key={i} value={l.value}>
              {l.label}
            </MenuItem>
          ))}

          {/* <MenuItem value="Hindi">Hindi</MenuItem> */}
        </Select>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
